module.exports = __webpack_public_path__ + "media/images/workflow-img-aca1939f18c8afd1c8d67a8479f2cd23.jpg";